import Script from 'next/script'
import { useEffect, useMemo, useState } from 'react'
import useScrollTop from '~/hooks/useScrollTop'
import { MyIcon } from '../ui/MyIcon'
import { useRouter } from 'next/router'

const hideBusinessReg =
  /^(\/note\/|\/plaza\/|\/collection\/|\/collection\/private\/)(\[id\]|[\d]+)/

export const RightBar = () => {
  const router = useRouter()
  const [hasNum, setHasNum] = useState(false)
  const [hasCustomerNum, setHasCustomerNum] = useState(false)

  const scrollTop = useScrollTop()
  const showScrollTop = scrollTop > 1000
  const hideBusiness = useMemo(
    () => hideBusinessReg.test(router.pathname),
    [router.pathname]
  )

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const getMeiqia = () => {
    return {
      __html: `
      (function(a, b, c, d, e, j, s) {
        a[d] = a[d] || function() {
            (a[d].a = a[d].a || []).push(arguments)
        };
        j = b.createElement(c),
            s = b.getElementsByTagName(c)[0];
        j.async = true;
        j.charset = 'UTF-8';
        j.src = 'https://static.meiqia.com/widget/loader.js';
        s.parentNode.insertBefore(j, s);
      })(window, document, 'script', '_MEIQIA');
      _MEIQIA('entId', '40d34b649ed60b6b051e858271ce4f66');
      _MEIQIA('manualInit');
      _MEIQIA('withoutBtn');
      _MEIQIA('fallback', 1);
    `,
    }
  }
  // 商务合作
  const openModal = () => {
    window._MEIQIA('showPanel', {
      groupToken: '4d6d29bd0c7691d5a241e4c6f45dbda0',
    })
  }
  // 客服 -- 无界ai小助手
  const openCustomerModal = () => {
    window._MEIQIA('showPanel', {
      groupToken: 'ecb660c30856bddfbb9edfb6746257f9',
    })
  }

  useEffect(() => {
    window._MEIQIA('getUnreadMsg', (msg: any) => {
      if (msg === 'hasBeenRead') {
        setHasNum(false)
        setHasCustomerNum(false)
      } else if (typeof msg === 'object') {
        const group_id = msg?.[0]?.agent?.group_id
        if (group_id === 736764) {
          // 商务合作
          setHasNum(true)
        } else if (group_id === 781446) {
          // 客服 -- 无界ai小助手
          setHasCustomerNum(true)
        }
      }
    })
    window._MEIQIA('init')
  }, [])

  return (
    <div className="fixed bottom-3 right-3 z-50">
      {showScrollTop && (
        <div
          onClick={handleScrollTop}
          className="flex items-center
          justify-center w-10 h-10 rounded-[32px] border-solid border-neutral-200 border bg-neutral-50/80 cursor-pointer mb-2"
        >
          <MyIcon
            icon="fanhuidingbu"
            className="text-neutral-500 text-[24px]"
          />
        </div>
      )}
      {!hideBusiness && (
        <div
          className="flex items-center
        justify-center flex-wrap w-10 py-2 rounded-[32px] border-solid border-neutral-200 border bg-neutral-50/80 cursor-pointer"
        >
          <div className="mb-2" onClick={openCustomerModal}>
            <div className="relative">
              <MyIcon
                icon="connect-filled"
                className="text-[24px] text-neutral-500 block"
              />
              {hasCustomerNum && (
                <span className="absolute -right-0.5 -top-0.5 w-2 h-2 rounded-full bg-[#ef466f]"></span>
              )}
            </div>
            <div className="text-[12px] text-neutral-500 leading-4">客服</div>
          </div>
          <div onClick={openModal}>
            <div className="relative">
              <MyIcon
                icon="cooperation"
                className="text-[24px] text-neutral-500 block"
              />
              {hasNum && (
                <span className="absolute -right-0.5 -top-0.5 w-2 h-2 rounded-full bg-[#ef466f]"></span>
              )}
            </div>
            <div className="text-[12px] text-neutral-500 leading-4">合作</div>
          </div>
        </div>
      )}
      <Script
        id="meiqia"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={getMeiqia()}
      />
    </div>
  )
}
